import Swal from 'sweetalert2';
import { TranslateFn } from 'hooks/useTranslate';

import { store } from 'redux/store';
import { Society, User } from 'types';

import getSocietyLogoSrc from 'modules/_shared/components/Logos/getSocietyLogo';
import { sendCommEmail } from 'modules/communications/redux/communicationActions';
import { confirmationModalCreator } from 'modules/_shared/components/Modals/utils/confirmationModalCreator';
import { BeneficiaryWithEnvelopeId } from 'modules/beneficiaries/hooks/useGetBeneficiariesPendingEnvelopes';
import { generateSendReminderBody } from './generateSendReminderBody';

type SendReminderProps = {
  t: TranslateFn;
  actualSociety: Society;
  user: User;
  beneficiaries: BeneficiaryWithEnvelopeId[];
};

const sendReminder = async ({
  t,
  actualSociety,
  user,
  beneficiaries,
}: SendReminderProps) => {
  Swal.fire({
    html: confirmationModalCreator({
      title: t('SendReminder'),
      footer: t('SendReminderPendingInvitationsFootMessage'),
      message: t('SendReminderPendingInvitations', {
        societyName: actualSociety.name,
      }),
    }),
    confirmButtonText: t('SendNow'),
    confirmButtonColor: '#6576ff',
    showCloseButton: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const recipients = beneficiaries.map((recipient) => ({
          email: recipient.email,
          name: recipient.name,
        }));

        const recipientsForDynamicData = beneficiaries.map((recipient) => {
          const { _id, email, name } = recipient;
          return {
            id: _id,
            email: email ? email.trim() : '',
            name,
          };
        });

        const societyName = actualSociety?.name || '-';

        const emailData = {
          to: recipients,
          cc: '',
          bcc: '',
          files: [],
          subject: t('SendReminderPendingInvitationsEmailSubject'),
          bodySummary: t('ApreciatedBeneficiary'),
          template: 'invitation-letter-reminder-es',
          templateBody: generateSendReminderBody(actualSociety),
          templateData: [{ name: 'societyName', content: societyName }],
          templateDynamicData: recipientsForDynamicData.map(
            ({ name, email }) => ({
              rcpt: email,
              vars: [
                { name: 'name', content: name },
                { name: 'email', content: email },
              ],
            })
          ),
          user: user['_id'],
          society: actualSociety['_id'],
          date: new Date(),
        };
        await store.dispatch(sendCommEmail(emailData));
      } catch (error) {
        console.log(error);
      }
    }
  });
};

export default sendReminder;
